import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  headers: { "Content-Type": "application/json" },
});

export const getDestinations = () => api.get("/destinations").then((r) => r.data);
export const getDestination = (slug) => api.get(`/destinations/${slug}`).then((r) => r.data);
export const getInstitutions = () => api.get("/institutions").then((r) => r.data);
export const getInstitution = (slug) => api.get(`/institutions/${slug}`).then((r) => r.data);
export const getScholarships = () => api.get("/scholarships").then((r) => r.data);
export const getNews = () => api.get("/news").then((r) => r.data);
export const getArticle = (slug) => api.get(`/news/${slug}`).then((r) => r.data);
export const postEnquiry = (data) => api.post("/enquiries", data).then((r) => r.data);
export const postConsultation = (data) => api.post("/consultations", data).then((r) => r.data);
export const postPartnerEnquiry = (data) => api.post("/partner-enquiries", data).then((r) => r.data);
export const postPathwayEnquiry = (data) => api.post("/pathway-enquiries", data).then((r) => r.data);
